'use strict';

const _ = require('lodash');

const AnnotationItemController = function (
    $scope, $rootScope, Flux, AppDialogsActions, DashDialogsActions,
    PlanStore, AnalyticsService
) {

  const vm = this;
  const AnnotationStore = Flux.Store.get('AnnotationStore');
  const MapStore = Flux.Store.get('MapStore');
  const MapActions = Flux.Actions.get('MapActions');

  vm.layers = [];
  vm.selected = {};

  // Flag for when annotation is saving
  vm.saving = false;

  // Means annotation has no layers, flag for disabling save button
  vm.empty = true;

  // Hash to hold the variable opacities for the possible sliders for the overlay layers
  vm.layerOpacities = {};

  vm._formatLayer = (layer) => {

    return  {
      id: layer.id,
      annotationId: layer.annotationId,
      name: layer.label,
      label: layer.label,
      type: layer.type,
      createdAt: new Date(layer.createdAt),
      ref: 'annotation_layer-' + layer.annotationId + '-' + layer.id,
      opacity: layer.overlay ? layer.overlay.opacity : layer.opacity
    };
  };

  vm._overlayExists = (layer) => {

    if (layer.type === 'overlay') {

      const OverlayStore = Flux.Store.get('OverlayStore');
      const available = OverlayStore.get('available');
      const element = _.find(available, 'id', layer.overlayId);
      if (!element || element.isDeleted) {
        return false;
      }
    }
    return true;
  };

  vm.itemClass = (data) => {

    return 'annotation-layer-' + data.type;
  };

  vm.setLayers = (annotation) => {

    vm.layers = _.sortBy(
      annotation.annotationLayers.filter(vm._overlayExists).map(vm._formatLayer),
      'createdAt'
    ).reverse();
    vm.layers.forEach((layer) => {
      var ref = 'annotation_layer-' + layer.annotationId + '-' + layer.id;
      vm.layerOpacities[ref] = (layer.opacity || 1) * 100;
    });
    vm.empty = vm.layers.length === 0;
  };

  // Controller may be instantiated after the active annotation has been selected,
  // so read in the initial state as well
  var initialAnnotation = AnnotationStore.get('active');
  if (initialAnnotation) {
    vm.setLayers(initialAnnotation);
  }

  vm.name = (...args) => {

    var activeAnnotation = AnnotationStore.get('active');
    if (activeAnnotation) {
      if (args.length === 0) { // Getter
        return activeAnnotation.name;
      }
      else { // Setter
        AnnotationStore.changeActiveName(args[0]);
        return activeAnnotation;
      }
    }
    return null;
  };

  // TODO: This could possibly be cached so a new instance doesn't have to be
  // returned each time
  vm.isNewRecord = () => {

    var annotation = AnnotationStore.get('active');
    return AnnotationStore.isNewRecord(annotation);
  };

  /**
   * Save the annotation
   */
  vm.save = () => {

    const annotation = AnnotationStore.get('active');
    const currentPlan = PlanStore.get('current');

    if (currentPlan && !currentPlan.isEnabled) {
      const segment = AnnotationStore.isNewRecord(annotation) ?
        'Annotation create - Disabled plan' :
        'Annotation edit - Disabled plan';
      AnalyticsService.track('[CORE] Subscription', segment, {});
      AppDialogsActions.MustBePayingCustomer.dispatch();
      return;
    }

    const canPlanAnnotate = PlanStore.checkFeature('project', 'annotations');
    if (!canPlanAnnotate) {
      const segment = AnnotationStore.isNewRecord(annotation) ?
        'Annotation create - Insufficient plan' :
        'Annotation edit - Insufficient plan';
      AnalyticsService.track('[CORE] Subscription', segment, {});
      DashDialogsActions.NotSupportedInPlanWarning.dispatch();
      return;
    }

    if (vm.saving === true) {
      return;
    }

    if (vm.empty === true) {
      $rootScope.$broadcast('dialog:annotation:infoEmptyAnnotation');
      return;
    }

    vm.saving = true;
    MapActions.SaveActiveAnnotation.dispatch();
    // TODO: This should use the `waitFor` functionality of flux model.
    // Use a custom event for now instead
    AnnotationStore.once(AnnotationStore.Events.ActiveSaved, () => {

      MapActions.AnnotationEditEnd.dispatch(true);
      vm.saving = false;
    });
  };

  vm.activateLayer = (layerId) => {

    MapActions.SetActiveLayer.dispatch(layerId);
  };

  vm.closeDrawer = (options) => {

    options = options || {};
    if (options.prompt && AnnotationStore.activeAnnotationChanged()) {
      $rootScope.$broadcast(options.prompt);
    }
    else {
      MapActions.AnnotationEditEnd.dispatch(false);
    }
  };

  vm.cancel = () => {

    if (AnnotationStore.activeAnnotationChanged()) {
      $rootScope.$broadcast('dialog:annotation:promptCancelEdit');
    }
    else {
      MapActions.AnnotationEditEnd.dispatch(false);
    }
  };

  vm.getActionLabel = () => {

    var annotation = AnnotationStore.get('active');
    if (AnnotationStore.isNewRecord(annotation)) {
      return 'New Annotation';
    }
    else {
      return 'Edit Annotation';
    }
  };

  vm.deleteOverlayLayer = (label) => {

    var activeAnnotation = AnnotationStore.get('active');
    vm.setOverlayAsActiveLayer(activeAnnotation, label);
    MapActions.DeleteActiveAnnotationLayer.dispatch();
  };

  vm.setOverlayAsActiveLayer = (annotation, label) => {

    var layers = annotation.annotationLayers;
    var activeLayer = _.filter(layers, (layer) => {
      return layer.label === label;
    });

    MapStore.$set('activeAnnotationLayerId', activeLayer[0].id);
  }

  $scope.$on('dialog:annotation:confirmCancelEdit', () => {

    MapActions.AnnotationEditEnd.dispatch(false);
  });

  $scope.$watch(() => {

    return vm.layerOpacities;
  }, (newValues, oldValues) => {

    _.forEach(newValues, (newValue, key) => {

      if (newValue && oldValues[key] !== newValue) {
        $rootScope.$broadcast('overlay:opacity:changed', key, newValue / 100);
        const match = key.match(/annotation_layer-(\d+)-(\d+)/);
        if (match) {
          const annotationId = parseInt(match[1], 10);
          const annotationLayerId = parseInt(match[2], 10);
          MapActions.ChangeAnnotationOverlayOpacity.dispatch(annotationId, annotationLayerId, newValue / 100);
        }

      }
    });
  }, true);

  vm.getFontClass = (layer) => {

    switch(layer.type) {
    case 'rectangle':
      return 'fa fa-icon-core-annotations-rectangle';
    case 'circle':
      return 'fa fa-icon-core-annotations-circle';
    case 'polygon':
      return 'fa fa-icon-core-annotations-polygon';
    case 'polyline':
      return 'fa fa-icon-core-annotations-line';
    case 'text':
      return 'fa fa-icon-core-annotations-text';
    case 'marker':
      return 'fa fa-icon-marker';
    case 'overlay':
      return 'fa fa-icon-core-overlays';
    default:
      return 'fa-unknown-' + layer.type;
    }
  };

  vm.handleAnnotationsChange = () => {

    var activeAnnotation = AnnotationStore.get('active');
    if (activeAnnotation) {
      vm.saving = false;
      vm.setLayers(activeAnnotation);
      vm.empty = vm.layers.length === 0;
    }
  };

  vm.handleActiveLayerChange = (activeLayerId) => {

    if (activeLayerId && !vm.selected[activeLayerId]) {
      var selected = {};
      selected[activeLayerId] = _.find(vm.layers, 'id', activeLayerId);
      vm.selected = selected;
    }
  };

  vm.handleAnnotationsSaveError = () => {

    $rootScope.$broadcast('dialog:annotation:permissionsError');
  };


  MapStore.on(MapStore.Events.ActiveLayerChanged, this.handleActiveLayerChange.bind(this), $scope);
  AnnotationStore.on(AnnotationStore.Events.Changed, this.handleAnnotationsChange.bind(this), $scope);
  AnnotationStore.on(AnnotationStore.Events.LayerRenamed, this.handleAnnotationsChange.bind(this), $scope);
  AnnotationStore.on(AnnotationStore.Events.Error, this.handleAnnotationsSaveError.bind(this), $scope);

};

AnnotationItemController.$inject = [
  '$scope', '$rootScope', 'sbFlux', 'AppDialogsActions', 'DashDialogsActions',
  'PlanStore', 'AnalyticsService'
];
module.exports = AnnotationItemController;



// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/annotations/item/AnnotationItemController.js